import React from 'react';
import { HiOutlineExternalLink } from 'react-icons/hi';

import FrontEndSkills from './FrontEndSkills';
import BackEndSkills from './BackEndSkills';
import OtherSkills from './OtherSkills';

const Skills = () => {
    return (
        <section id="skills" className="px-4 lg:px-60 md:px-32">
            <div className="py-16">
                <h2 className="text-4xl text-accent mb-5 font-bold text-center">
                    My Skills
                </h2>
                <FrontEndSkills></FrontEndSkills>
                <BackEndSkills></BackEndSkills>
                <OtherSkills></OtherSkills>
            </div>
            {/* ----------------experience section---------------- */}
            <div
                data-aos="zoom-in"
                data-aos-duration="2000"
                className="text-center"
            >
                <h2 className="text-4xl font-bold text-accent">Experience</h2>
                <p className="lg:text-3xl text-xl mt-5 lg:w-2/3 md:w-2/3 sm:w-full mx-auto leading-normal lg:leading-[3rem]">
                    It should be noted that I worked at{' '}
                    <span className="text-accent font-bold">Fiverr</span> as a
                    front-end web developer and SEO consultant. Feel free to
                    check my Fiverr Level One profile by <br />{' '}
                    <a
                        className="text-accent font-bold flex items-center justify-center"
                        href="https://www.fiverr.com/palak_wpseo"
                        target="_blank"
                        rel="noreferrer"
                    >
                        clicking here <HiOutlineExternalLink className="ml-1" />
                    </a>
                </p>
            </div>
            <div id="portfolio">
                <p className="hidden">Hello</p>
            </div>
        </section>
    );
};

export default Skills;
